import LivePayoutsApiClient from "../api/LivePayoutsApi";
export const useLivePayoutsApi = (getToken) => {
    return new LivePayoutsApiClient(getToken);
};
